export function initEuCampaign() {
    const asideEl = document.getElementById('euCampaign');
    if (window.location.pathname === '/' && window.location.search.indexOf('standard') > 0) {
        window.history.replaceState({}, '', window.location.href.replace(/((&)|[?])standard(&|$)/, '$2'));
    }
    if (asideEl) {
        initHomeOverlay(asideEl);
    }
}

/**
 * @param {HTMLElement} rootEl
 */
function initHomeOverlay(rootEl) {

    const otherEls = [
        document.getElementById('scontent'),
        document.getElementById('dth'),
        document.getElementById('mbh'),
        document.getElementById('hdrsrch'),
        document.getElementById('sfoot'),
    ].filter(el => el);
    otherEls.forEach(el => {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('inert', 'inert');
    });

    rootEl.addEventListener('click', event => {
        const closestAnchor = event.target.closest('a');
        if (closestAnchor?.href.replace(/\/?([?#].*)*$/, '') === window.location.href.replace(/\/$/, '')) {
            event.preventDefault();
            close();
        }
    });

    function close() {
        document.body.classList.remove('with--euCampaign');
        rootEl.parentElement.removeChild(rootEl);
        otherEls.forEach(el => {
            el.removeAttribute('aria-hidden');
            el.removeAttribute('inert')
        });
    }
}
